import { styled } from "@mui/material/styles";

export const AvailabilitySelectWrapper = styled("div")((props) => ({
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "column",
    background: "#F6F6F6",
    width: "100%",
    padding: "1.5rem",
    [props.theme.breakpoints.down("lg")]: {
        padding: "1.5rem 0.5rem 0.5rem",
    },
}));
